import React from "react";
import "./AppPanel.scss";
import CoralRecTourism from "./CoralRecTourism/CoralRecTourism";
import AppPanelHeader from "../AppPanelHeader/AppPanelHeader";
import RecFishing from "./RecFishing/RecFishing";
import WildLifeTourism from "./WildlifeTourism/WildLifeTourism";
import Fisheries from "./Fisheries/Fisheries";
import Intro from "./Intro/Intro";
import BeachRecTourism from "./BeachRecTourism/BeachRecTourism";

function AppPanel(props) {

  const { setApp } = props;

  const renderAppForQueryString = () => {
    const { app } = props;

    switch(app) {
      case 'intro':
        return (
          <>
            <AppPanelHeader setApp={setApp} hideClose={true} title="Get Started" />
            <Intro setApp={setApp}/>
          </>
        )
      case 'coral-rec-tourism':
        return (
          <>
            <AppPanelHeader setApp={setApp} title="Coral Reef Recreation and Tourism" />
            <CoralRecTourism />
          </>
        );
      case 'beach-rec-tourism':
        return (
          <>
            <AppPanelHeader setApp={setApp} title="Beach Recreation and Tourism" />
            <BeachRecTourism />
          </>
        );
      case 'rec-fishing':
        return (
          <>
            <AppPanelHeader setApp={setApp} title="Recreational Fishing" />
            <RecFishing />
          </>
        );
      case 'coral-reef-fisheries':
        return (
          <>
            <AppPanelHeader setApp={setApp} title="Coral Reef Fisheries" />
            <Fisheries />
          </>
        );
      case 'wildlife-tourism':
        return (
          <>
            <AppPanelHeader setApp={setApp} title="Wildlife Tourism" />
            <WildLifeTourism />
          </>
        );
      default:
        return (
          <>
            <AppPanelHeader setApp={setApp} hideClose={true} title="Get Started" />
            <Intro setApp={setApp} />
          </>
        );
    }
  }
  return (
    <div className="appPanel">
      {renderAppForQueryString()}
    </div>
  );
}

export default AppPanel;
